import { Switch, Td, Tr } from "@chakra-ui/react";
import { MinhaFormaPagamentoResponse } from "core/features/forma-pagamento/typings";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";

export default function MethodItem({
  value,
  item,
  onChange,
  hideTaxas,
}: {
  value: boolean;
  item: MinhaFormaPagamentoResponse;
  onChange?: (v: any) => void;
  hideTaxas?: boolean;
}) {
  const getValor = (valor: number) => {
    if (!valor) {
      return "Sem Taxa";
    }

    if (item.tipo === "porcentagem") {
      return `${formatCurrency(Number(valor))}%`;
    }

    return `R$ ${formatCurrency(Number(valor))}`;
  };

  return (
    <Tr pb={2}>
      <Td borderWidth={1} borderRightWidth={0} borderLeftRadius="2xl">
        {item.nome}
      </Td>

      {!hideTaxas && <Td fontWeight={"bold"} borderTopWidth={1} borderBottomWidth={1}>
        {item.tipo ? getValor(item.taxaPadrao + item.taxaExtra) : "---"}
      </Td>}
      <Td borderWidth={1} borderLeftWidth={0} borderRightRadius="2xl">
        <Switch
          isChecked={value}
          onChange={() => {
            onChange?.(!value);
          }}
          size="lg"
        />
      </Td>
    </Tr>
  );
}
